let config;

// Get the environment based on hostname
const environment = window.location.hostname;

if (environment === "localhost") {
    // Load local config for localhost
    config = require("./config.localenv").default;
} else if (environment === "test.glassyfied.com") {
    // Load test config for test subdomain
    config = require("./config.testenv").default;
} else if (environment === "glassyfied.com") {
    // Load production config for production domain
    config = require("./config.prodenv").default;
} else {
    // Default to production config if no environment matches
    config = require("./config.prodenv").default;
}

// Common settings across all environments
config = {
    ...config,
    supportMail: "contact@glassyfied.com",
    phoneNumber: "(+91) 6387927661",
    MAX_TOKENS: 6000,
    APPROX_CHARS_PER_TOKEN: 4,
};

export default config;
